/* istanbul ignore file */

import { IFetchComparatorDataAsync } from '../../redux/comparatorSlice/thunk';
import { fetchComparatorDataMock } from '../../__mocks__/comparator';
import fetchParams from './fetchParams';

export const fetchComparatorData = async ({ ...props }: IFetchComparatorDataAsync) => {
  if (props.environment === 'development') {
    return fetchComparatorDataMock;
  }

  const { url, params } = fetchParams.getComparatorData({ ...props });
  const response = await fetch(url, params);
  return await response.json();
};
